export default "/static/dashboard/build/app/img/v2/2892f3d84624976110d096477492cccd.png";